import * as ng from 'angular';
import { ArchiSmallServices } from '../../../services/archismall.service';

class ListiniController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    'ArchiSmallServices',
    '$timeout',
    '$uibModalStack',
    '$state'
  ];

  private close: any;
  private dismiss: any;

  constructor(
    private $scope: any,
    private $rootScope: any,
    private ArchiSmallServices: ArchiSmallServices,
    private $timeout: ng.ITimeoutService,
    private $modalStack: ng.ui.bootstrap.IModalStackService,
    private $state: any
  ) {
    $scope.updateInProgress = true;
    $scope.updateWithError = false;

    if ($scope.$parent.$resolve.update) {
      ArchiSmallServices.updateListino($scope.$parent.$resolve.listino)
        .then(response => {
          $timeout(() => {
            $scope.updateInProgress = false;
            $modalStack.getTop().value.keyboard = true;
            $modalStack.getTop().value.backdrop = true;
            $state.go('home.gestione-listino');
            $scope.cancel();
          }, 2000);
        }, (error) => {
          $rootScope.alert('error', error);
          $scope.cancel();
        });
    } else {
      ArchiSmallServices.createListino($scope.$parent.$resolve.listino)
        .then((response) => {
          $timeout(() => {
            $scope.updateInProgress = false;
            $modalStack.getTop().value.keyboard = true;
            $modalStack.getTop().value.backdrop = true;
            $state.go('home.gestione-profili');
            $scope.cancel();
          }, 2000);
        }, (error) => {
          $rootScope.alert('error', error);
          $scope.cancel();
        });
    }



    $scope.ok = () => {
      this.close();
    };
    $scope.cancel = () => {
      this.dismiss({ $value: 'cancel' });
    };
  }
}

export const ListiniComponent: ng.IComponentOptions = {
  template: require('./listini.html'),
  controller: ListiniController,
  bindings: {
    close: '&',
    dismiss: '&'
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/listini/listini.ts